import { FC } from "react";
import { useParams } from "react-router-dom";
import { AuthenticatedLayout } from "../../layouts";
import { DraftEmployeesLayout } from "../../components/DraftEmployeesLayout";

export interface IDraftEmployeePage {}
export const DraftEmployeePage: FC<IDraftEmployeePage> = () => {
  return (
    <AuthenticatedLayout
      pageTitle={`Draft Employees`}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        // { text: `Draft Employee`, navigateTo: `/employee/draft` }
      ]}
      mainContents={<DraftEmployeesLayout />}
    />
  );
};
